// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-solidity-detector-task-dialog[data-v-4027825c] .el-dialog{width:var(--common-dialog-large-width)}.create-solidity-detector-task-dialog .el-form[data-v-4027825c]{margin-right:var(--base-size-48)}.create-solidity-detector-task-dialog .el-select[data-v-4027825c]{width:100%}", ""]);
// Exports
module.exports = exports;
